import './index.erb';
import './index.rb';

export default class QuestionsInterventionModal {
  constructor() {
    this.$context = $('#js-questions-intervention-modal');
    this.$tip = $('.js-tip-intervention', this.$context);
    this.$icon = $('.js-toggle-icon', this.$context);
    this.$content = $('.js-content-intervention', this.$context);
    this.$btn = $('.js-btn-intervention', this.$context);

    this.bind();
  }

  closeModal() {
    if (!localStorage) {
      return;
    }

    const isClosedQuestionsIntervention =
      localStorage.getItem('closedQuestionsIntervention') === 'true';

    if (isClosedQuestionsIntervention) {
      return this.$context.remove();
    }
  }

  showContent() {
    this.$icon.on('click', () => {
      this.$content.toggle('slow', () => this.$tip.hide());
    });
  }

  hideContent() {
    this.$btn.on('click', () => {
      this.$context.animate(
        {
          opacity: 0.25,
          left: '+=100'
        },
        100,
        () => {
          this.$context.remove();

          if (localStorage) {
            localStorage.setItem('closedQuestionsIntervention', true);
          }
        }
      );
    });
  }

  showModalAfterScroll() {
    const refContext = this.$context;
    const animateSlow = 'slow';

    $(document).on('scroll', function () {
      const mobile = $(this).width() <= 765;
      let scrollTop = $(this).scrollTop();
      let screenMiddle = scrollTop >= 200;
      let screenTop = scrollTop === 0;

      if (mobile && screenTop) {
        refContext.slideUp(animateSlow);
      } else if (mobile && screenMiddle) {
        refContext.slideDown(animateSlow);
      }
    });
  }

  bind() {
    this.closeModal();
    this.showContent();
    this.hideContent();
    this.showModalAfterScroll();
  }
}

new QuestionsInterventionModal();
